import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withModifiers as _withModifiers, vShow as _vShow, Transition as _Transition, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["part"]
const _hoisted_2 = {
  key: 0,
  class: "d-flex h-100 flex-column"
}
const _hoisted_3 = { class: "d-grid gap-3 d-md-flex justify-content-md-end align-items-center mb-4" }
const _hoisted_4 = { class: "overflow-hidden text-nowrap" }
const _hoisted_5 = {
  key: 1,
  class: "my-4 p-2 text-center bg-light"
}
const _hoisted_6 = {
  class: "bg-white",
  style: {"z-index":"4"}
}
const _hoisted_7 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_8 = { class: "d-inline-block me-2" }
const _hoisted_9 = {
  class: "sticky-top bg-white",
  style: {"z-index":"3"}
}
const _hoisted_10 = {
  ref: "topSection",
  class: "table-responsive pb-2",
  style: {"flex":"none"}
}
const _hoisted_11 = {
  class: "table table-sm mb-0 table-borderless table-first-col-sticky",
  style: {"height":"100%"}
}
const _hoisted_12 = { class: "h-100" }
const _hoisted_13 = { class: "h-100" }
const _hoisted_14 = {
  class: "bg-white",
  style: {"vertical-align":"top"}
}
const _hoisted_15 = {
  key: 1,
  class: "my-2"
}
const _hoisted_16 = { class: "form-check form-switch" }
const _hoisted_17 = {
  class: "form-check-label",
  for: "compareDifferencesOnly"
}
const _hoisted_18 = { class: "border border-1 border-bottom-0 rounded-top h-100 position-relative" }
const _hoisted_19 = { class: "position-absolute top-0 start-100 translate-middle" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "position-relative col d-flex justify-content-center align-items-top" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "text-center mt-2" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = {
  key: 0,
  class: "h-100"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("td", { class: "bg-white" }, null, -1)
const _hoisted_27 = {
  key: 1,
  class: "h-100"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("td", { class: "bg-white" }, null, -1)
const _hoisted_29 = { class: "p-2" }
const _hoisted_30 = {
  key: 2,
  class: "h-100"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("td", { class: "bg-white" }, null, -1)
const _hoisted_32 = { class: "text-center border border-1 border-top-0 rounded-bottom h-100 py-3" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { ref: "visibilityTest" }
const _hoisted_35 = { class: "table table-sm table-first-col-sticky" }
const _hoisted_36 = ["colspan"]
const _hoisted_37 = {
  class: "pis-heading mt-2 d-inline-block",
  style: {"position":"sticky","left":"0"}
}
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { style: {"vertical-align":"top"} }
const _hoisted_40 = { class: "d-flex" }
const _hoisted_41 = { class: "w-100" }
const _hoisted_42 = { class: "ps-lg-3" }
const _hoisted_43 = ["innerHTML", "title"]
const _hoisted_44 = {
  key: 0,
  class: "flex-shrink-1 px-2"
}
const _hoisted_45 = {
  key: 0,
  class: "text-center text-muted"
}
const _hoisted_46 = /*#__PURE__*/_createElementVNode("strong", null, "N/A", -1)
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = {
  key: 1,
  class: "text-center text-muted"
}
const _hoisted_49 = /*#__PURE__*/_createElementVNode("strong", null, "Y", -1)
const _hoisted_50 = [
  _hoisted_49
]
const _hoisted_51 = {
  key: 2,
  class: "text-center"
}
const _hoisted_52 = ["onClick"]
const _hoisted_53 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InjectStyles = _resolveComponent("InjectStyles")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_LinkSecondary = _resolveComponent("LinkSecondary")!
  const _component_NavigationBtns = _resolveComponent("NavigationBtns")!
  const _component_CategoryFilter = _resolveComponent("CategoryFilter")!
  const _component_VRuntimeTemplate = _resolveComponent("VRuntimeTemplate")!
  const _component_Image = _resolveComponent("Image")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_PisReplacements = _resolveComponent("PisReplacements")!
  const _component_InteractiveText = _resolveComponent("InteractiveText")!
  const _component_PisLink = _resolveComponent("PisLink")!
  const _component_CompareTableData = _resolveComponent("CompareTableData")!

  return (_openBlock(), _createElementBlock("div", {
    ref: "root",
    class: _normalizeClass(["pis-component", _ctx.componentName]),
    part: _ctx.componentName
  }, [
    (_ctx.isReady)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.isWebComponent)
            ? (_openBlock(), _createBlock(_component_InjectStyles, {
                key: 0,
                items: _ctx.store?.options.styles
              }, null, 8, ["items"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            (_ctx.componentOptions.printButtonVisible)
              ? (_openBlock(), _createBlock(_component_LinkSecondary, {
                  key: 0,
                  class: "d-flex align-items-center ext-print-view small",
                  onClick: _ctx.print
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Icon, {
                      glyph: "print",
                      class: "me-1",
                      lg: ""
                    }),
                    _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.t('ShowPrintView')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            (_ctx.componentOptions.navigationVisible)
              ? (_openBlock(), _createBlock(_component_NavigationBtns, {
                  key: 1,
                  instance: _ctx.instance,
                  t: _ctx.t
                }, null, 8, ["instance", "t"]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.noItemsFound)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.t('CompareNoProductsSelected')), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            (_ctx.componentOptions.categoriesVisible && _ctx.categories.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("small", _hoisted_8, _toDisplayString(_ctx.t('Categories', true)) + ":", 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (cat) => {
                    return (_openBlock(), _createBlock(_component_CategoryFilter, {
                      key: cat.cid,
                      cat: cat,
                      selectedCid: _ctx.selectedCid,
                      onSelect: _ctx.filterByCid
                    }, null, 8, ["cat", "selectedCid", "onSelect"]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("table", _hoisted_11, [
                _createElementVNode("colgroup", null, [
                  _createElementVNode("col", {
                    style: _normalizeStyle({
                  width: _ctx.componentOptions.attrColWidth,
                  'max-width': _ctx.componentOptions.attrColWidth,
                  'min-width': _ctx.componentOptions.attrColWidth,
                })
                  }, null, 4),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
                    return (_openBlock(), _createElementBlock("col", {
                      key: index,
                      style: _normalizeStyle({
                  width: _ctx.componentOptions.valColWidth,
                  'max-width': _ctx.componentOptions.valColWidth,
                  'min-width': _ctx.componentOptions.valColWidth,
                })
                    }, null, 4))
                  }), 128))
                ]),
                _createElementVNode("tbody", _hoisted_12, [
                  _createElementVNode("tr", _hoisted_13, [
                    _createElementVNode("td", _hoisted_14, [
                      (_ctx.componentOptions.headerTemplate && _ctx.items.length)
                        ? (_openBlock(), _createBlock(_component_VRuntimeTemplate, {
                            key: 0,
                            template: _ctx.componentOptions.headerTemplate,
                            "template-props": {
                        instance: _ctx.instance,
                        selectedCid: _ctx.selectedCid,
                        categories: _ctx.categories,
                        emit: _ctx.emit,
                        t: _ctx.t,
                      }
                          }, null, 8, ["template", "template-props"]))
                        : _createCommentVNode("", true),
                      (_ctx.items.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, [
                              _withDirectives(_createElementVNode("input", {
                                class: "form-check-input",
                                type: "checkbox",
                                id: "compareDifferencesOnly",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.differencesOnly) = $event))
                              }, null, 512), [
                                [_vModelCheckbox, _ctx.differencesOnly]
                              ]),
                              _createElementVNode("label", _hoisted_17, [
                                _createElementVNode("strong", null, _toDisplayString(_ctx.t('CompareDifferencesOnly')), 1)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.map(a=>a.item!), (item, index) => {
                      return (_openBlock(), _createElementBlock("td", {
                        key: index,
                        style: {"vertical-align":"top"},
                        class: "h-100 p-3 pt-3 pb-0"
                      }, [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("a", {
                              href: "",
                              class: "text-white bg-dark rounded-circle ext-compare-remove d-flex align-items-center justify-content-center",
                              style: {"width":"1.2rem","height":"1.2rem"},
                              onClick: _withModifiers(($event: any) => (_ctx.removeItem(item)), ["prevent"])
                            }, [
                              _createVNode(_component_Icon, {
                                glyph: "close",
                                sm: ""
                              })
                            ], 8, _hoisted_20)
                          ]),
                          _createVNode(_Transition, { name: "fade" }, {
                            default: _withCtx(() => [
                              _withDirectives(_createElementVNode("div", {
                                class: "text-center m-auto py-4",
                                style: _normalizeStyle({ 'max-width': _ctx.componentOptions.imageSize })
                              }, [
                                _createElementVNode("div", _hoisted_21, [
                                  _createVNode(_component_Image, {
                                    style: _normalizeStyle({ 'max-width': _ctx.componentOptions.imageSize }),
                                    src: (item.images || [])[0]?.url,
                                    clickable: true,
                                    "hide-frame": true,
                                    "max-size-css": _ctx.componentOptions.imageSize,
                                    onClick: ($event: any) => (_ctx.details(item))
                                  }, null, 8, ["style", "src", "max-size-css", "onClick"]),
                                  (_ctx.componentOptions.imageOverlayTemplate)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                        _createVNode(_component_VRuntimeTemplate, {
                                          template: _ctx.componentOptions.imageOverlayTemplate,
                                          "template-props": { instance: _ctx.instance, item: item, emit: _ctx.emit, t: _ctx.t }
                                        }, null, 8, ["template", "template-props"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ], 4), [
                                [_vShow, _ctx.componentOptions.imageVisible && _ctx.imageVisible]
                              ])
                            ]),
                            _: 2
                          }, 1024),
                          _createElementVNode("div", _hoisted_23, [
                            (item.additionalInfo && item.additionalInfo.length)
                              ? (_openBlock(), _createBlock(_component_Tooltip, {
                                  key: 0,
                                  text: _ctx.additionalInfo(item.additionalInfo)
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Icon, {
                                      class: "text-warning me-1",
                                      glyph: "warning"
                                    })
                                  ]),
                                  _: 2
                                }, 1032, ["text"]))
                              : _createCommentVNode("", true),
                            (_ctx.componentOptions.titleTemplate)
                              ? (_openBlock(), _createBlock(_component_VRuntimeTemplate, {
                                  key: 1,
                                  template: _ctx.componentOptions.titleTemplate,
                                  "template-props": { instance: _ctx.instance, item, emit: _ctx.emit, details: _ctx.details, attrValue: _ctx.attrValue, t: _ctx.t }
                                }, null, 8, ["template", "template-props"]))
                              : (_openBlock(), _createElementBlock("a", {
                                  key: 2,
                                  href: "#",
                                  class: "fw-bold",
                                  onClick: _withModifiers(($event: any) => (_ctx.details(item)), ["prevent"])
                                }, _toDisplayString(_ctx.attrValue(item, '#DisplayName')), 9, _hoisted_24)),
                            (_ctx.componentOptions.showAllIdentifiers)
                              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.attrValues(item, '#AllIdentifiers'), (val, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "text-muted fw-bold",
                                    key: index
                                  }, _toDisplayString(val), 1))
                                }), 128))
                              : _createCommentVNode("", true),
                            (
                          item.replacements &&
                          item.replacements.length &&
                          _ctx.componentOptions.showReplacements
                        )
                              ? (_openBlock(), _createBlock(_component_PisReplacements, {
                                  key: 4,
                                  instance: _ctx.instance,
                                  replacements: item.replacements,
                                  visible: _ctx.replacementsVisible
                                }, null, 8, ["instance", "replacements", "visible"]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]))
                    }), 128))
                  ]),
                  (_ctx.componentOptions.itemTemplate)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_25, [
                        _hoisted_26,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.map(a=>a.item!), (item, index) => {
                          return (_openBlock(), _createElementBlock("td", {
                            key: index,
                            style: {"vertical-align":"top"},
                            class: "h-100 px-3 py-0"
                          }, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["text-center border border-1 border-top-0 h-100", [
                      _ctx.componentOptions.actionTemplate
                        ? 'border-bottom-0 pb-0'
                        : 'rounded-bottom pb-2',
                    ]])
                            }, [
                              _createElementVNode("div", null, [
                                _createVNode(_component_VRuntimeTemplate, {
                                  template: _ctx.componentOptions.itemTemplate,
                                  "template-props": { instance: _ctx.instance, item, emit: _ctx.emit, details: _ctx.details, attrValue: _ctx.attrValue, t: _ctx.t }
                                }, null, 8, ["template", "template-props"])
                              ])
                            ], 2)
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("tr", _hoisted_27, [
                        _hoisted_28,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.map(a=>a.item!), (item, index) => {
                          return (_openBlock(), _createElementBlock("td", {
                            key: index,
                            style: {"vertical-align":"top"},
                            class: "h-100 px-3 py-0"
                          }, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["text-center border border-1 border-top-0 rounded-bottom h-100", [
                      _ctx.componentOptions.actionTemplate
                        ? 'border-bottom-0 pb-0'
                        : 'rounded-bottom pb-2',
                    ]])
                            }, [
                              _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.attrValue(item, 'CatalogDescription')), 1)
                            ], 2)
                          ]))
                        }), 128))
                      ])),
                  (_ctx.componentOptions.actionTemplate)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_30, [
                        _hoisted_31,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.map(a=>a.item!), (item, index) => {
                          return (_openBlock(), _createElementBlock("td", {
                            key: index,
                            style: {"vertical-align":"top"},
                            class: "h-100 p-3 pt-0"
                          }, [
                            _createElementVNode("div", _hoisted_32, [
                              (!item.inactive)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                    _createVNode(_component_VRuntimeTemplate, {
                                      template: _ctx.componentOptions.actionTemplate,
                                      "template-props": { instance: _ctx.instance, item, emit: _ctx.emit, details: _ctx.details, attrValue: _ctx.attrValue, t: _ctx.t }
                                    }, null, 8, ["template", "template-props"])
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ], 512)
          ]),
          _createElementVNode("div", _hoisted_34, null, 512),
          _createElementVNode("div", {
            ref: "bottomSection",
            class: _normalizeClass(["table-responsive", { small: _ctx.componentOptions.compactMode }])
          }, [
            _createElementVNode("table", _hoisted_35, [
              _createElementVNode("colgroup", null, [
                _createElementVNode("col", {
                  style: _normalizeStyle({
                width: _ctx.componentOptions.attrColWidth,
                'max-width': _ctx.componentOptions.attrColWidth,
                'min-width': _ctx.componentOptions.attrColWidth,
              })
                }, null, 4),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
                  return (_openBlock(), _createElementBlock("col", {
                    key: index,
                    style: _normalizeStyle({
                width: _ctx.componentOptions.valColWidth,
                'max-width': _ctx.componentOptions.valColWidth,
                'min-width': _ctx.componentOptions.valColWidth,
              })
                  }, null, 4))
                }), 128))
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groups, (group) => {
                return (_openBlock(), _createElementBlock("tbody", {
                  key: group.code
                }, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", {
                      colspan: _ctx.items.length + 1,
                      class: "disable-sticky ps-0"
                    }, [
                      _createElementVNode("h4", _hoisted_37, _toDisplayString(group.description), 1),
                      (group.code == 'AdditionalFields')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                            _createElementVNode("a", {
                              href: "",
                              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.showMore = !_ctx.showMore), ["prevent"]))
                            }, _toDisplayString(_ctx.showMore ? _ctx.t('HideMore') : _ctx.t('ShowMore')), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_36)
                  ]),
                  (
                group.code != 'AdditionalFields' || (group.code == 'AdditionalFields' && _ctx.showMore)
              )
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(group.attributes, (attr) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: attr.attributeCode
                        }, [
                          _createElementVNode("td", _hoisted_39, [
                            _createElementVNode("div", _hoisted_40, [
                              _createElementVNode("div", _hoisted_41, [
                                _createElementVNode("div", _hoisted_42, [
                                  _createElementVNode("span", {
                                    class: "d-inline-block w-100 text-wrap fw-bold",
                                    style: {"overflow":"hidden","text-overflow":"ellipsis"},
                                    innerHTML: attr.attributeName + ':',
                                    title: attr.tooltip
                                  }, null, 8, _hoisted_43)
                                ])
                              ]),
                              (attr.internal)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                    _createVNode(_component_Tooltip, {
                                      text: _ctx.t('Internal', true)
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Icon, {
                                          class: "text-warning text-end",
                                          glyph: "warning"
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["text"])
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
                            return (_openBlock(), _createElementBlock("td", {
                              key: index,
                              style: {"vertical-align":"top","max-width":"0"},
                              class: "ext-compare-cell"
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getAttributes(
                      item,
                      group.code,
                      attr.attributeCode,
                    ), (itemAttr, itemAttrIndex) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "px-2 ext-compare-cell-wrapper",
                                  key: itemAttrIndex
                                }, [
                                  (itemAttr.type == _ctx.AttributeTypeEnum.NotApplicable)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_45, _hoisted_47))
                                    : (itemAttr.type == _ctx.AttributeTypeEnum.Populated)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_48, _hoisted_50))
                                      : (itemAttr.type == _ctx.AttributeTypeEnum.Table)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                                            _createElementVNode("a", {
                                              href: "",
                                              onClick: _withModifiers(($event: any) => (_ctx.compareTableData(group.code, attr.attributeCode)), ["prevent"])
                                            }, _toDisplayString(_ctx.t('CompareTableData')), 9, _hoisted_52)
                                          ]))
                                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(itemAttr.values, (attrValue, attrValueIndex) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: attrValueIndex,
                                              class: "text-center"
                                            }, [
                                              (attrValue.interactiveText)
                                                ? (_openBlock(), _createBlock(_component_InteractiveText, {
                                                    key: 0,
                                                    instance: _ctx.instance,
                                                    text: attrValue.interactiveText
                                                  }, null, 8, ["instance", "text"]))
                                                : (attrValue.link && !_ctx.hideDocumentLinks)
                                                  ? (_openBlock(), _createBlock(_component_PisLink, {
                                                      key: 1,
                                                      link: attrValue.link,
                                                      instance: _ctx.instance,
                                                      "clear-search": true
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(attrValue.link.text), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["link", "instance"]))
                                                  : (_openBlock(), _createElementBlock("div", {
                                                      key: 2,
                                                      class: "ext-compare-cell-content",
                                                      style: {"overflow":"hidden","text-overflow":"ellipsis","hyphens":"auto"},
                                                      innerHTML: attrValue.text
                                                    }, null, 8, _hoisted_53))
                                            ]))
                                          }), 128))
                                ]))
                              }), 128))
                            ]))
                          }), 128))
                        ]))
                      }), 128))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ], 2)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_CompareTableData, {
      "instance-id": _ctx.instance?.id,
      t: _ctx.t,
      items: _ctx.tableData,
      visible: _ctx.tableDataVisible
    }, null, 8, ["instance-id", "t", "items", "visible"])
  ], 10, _hoisted_1))
}